import React, { useContext, useEffect, useState } from 'react';
import './NavTest.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faFile, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { ColorsContext } from '../composants/colorContext';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../configurations/axiosInstance/AxiosInstance';
import { formatAuthor } from '../composants/utils/utils';
import { toast } from 'react-toastify';

export default function NavTestNew() {
  const [ressources, setRessources] = useState(false);
  const [about, setAbout] = useState(false);
  const [ressourcesM, setRessourcesM] = useState(false);
  const [aboutM, setAboutM] = useState(false);
  const { colors } = useContext(ColorsContext);
  const [isOpen, setIsOpen] = useState(false);
  const [articleSubMenu, setArticleSubMenu] = useState([]);
  const [partenaires, setPartenaires] = useState([]);

  const fetchPartenaires = async () => {
    try {
      const response = await axiosInstance().get('public/api/partenaires/active-published');
      setPartenaires(response.data || []);
    } catch (error) {
      //toast.error('Impossible de charger les partenaires');
      setPartenaires([]);
    }
  };

  const fetchMenus = () => {
    axiosInstance().get('/public/api/menu/WEB_SITE')
      .then(response => {
        let menusJson = response.data.subMenus;
        menusJson.sort((a, b) => a.name.localeCompare(b.name));
        setArticleSubMenu(menusJson);
      })
      .catch(error => { console.error('There was an error!', error); });
  };

  useEffect(() => {
    fetchMenus();
    fetchPartenaires();
  }, []);




  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname || '/');

  useEffect(() => {
    setActivePath(location.pathname || '/');
  }, [location]);

  const handleAnchorClick = (e) => {
    const href = e.currentTarget.getAttribute('href') || '';
    try {
      const url = new URL(href, window.location.origin);
      setActivePath(url.pathname);
    } catch (err) {
      setActivePath(href);
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-lg border-b border-gray-100 shadow-sm transition-all duration-300">
      <nav className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 w-full">
          {/* Left Logos (YouthFP + unfpa on mobile) */}
          <div className="flex items-center gap-4">
            <div className="flex-shrink-0 flex items-center">
              <a href="/" className="transition-transform hover:scale-105">
                <img src="/images/logo/logo.png" className="block h-10 w-auto" alt="YouthFP" />
              </a>
            </div>
            <div className="flex-shrink-0 flex items-center sm:hidden">
              <a href="https://cameroon.unfpa.org/" className='transition-transform hover:scale-105 no-underline' target="_blank" rel="noopener noreferrer">
                <img src="/images/logo/unfpa.png" className="block h-8 w-auto" alt="UNFPA" />
              </a>
            </div>
          </div>

          {/* Desktop Links */}
          <div className="hidden sm:flex flex-1 justify-center sm:ml-6">
            <div className="flex space-x-1 items-center">

              <a href="/" onClick={handleAnchorClick} className={`relative group px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300 no-underline ${activePath === '/' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-indigo-600 hover:bg-gray-50'}`}>
                Accueil
              </a>

              <div className="relative group" onMouseEnter={() => setRessources(true)} onMouseLeave={() => setRessources(false)}>
                <button className={`relative group border-none px-4 py-2 rounded-full text-sm font-semibold flex items-center gap-2 transition-all duration-300 outline-none focus:outline-none ${activePath.startsWith('/articles') || activePath.startsWith('/usraj') || activePath.startsWith('/service') || activePath.startsWith('/gallery') ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-indigo-600 hover:bg-gray-50'}`}>
                  <FontAwesomeIcon icon={faFolderOpen} className="text-xs" /> Ressources
                  <FontAwesomeIcon icon={faChevronDown} className={`text-[10px] transition-transform duration-300 ${ressources ? 'rotate-180' : ''}`} />
                </button>

                <div className={`absolute left-1/2 -translate-x-1/2 pt-4 w-screen max-w-4xl transition-all duration-300 z-50 ${ressources ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-4 invisible'}`}>
                  <div className="bg-white border text-left border-gray-100 rounded-3xl shadow-xl shadow-indigo-100/50 p-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Column 1: Articles */}
                    {articleSubMenu.length !== 0 && (
                      <div className="space-y-6">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-xl bg-orange-50 text-orange-500 flex items-center justify-center">
                            <FontAwesomeIcon icon={faFile} />
                          </div>
                          <h3 className="text-lg font-bold text-gray-800 m-0">Articles</h3>
                        </div>
                        <ul className="space-y-3 p-0 m-0 list-none">
                          {articleSubMenu.map((menu) => (
                            <li key={menu.name}>
                              <a onClick={handleAnchorClick} className={`block text-sm transition-colors no-underline ${activePath === `/articles/${menu.id}` ? 'text-orange-600 font-semibold' : 'text-gray-500 hover:text-orange-500'}`} href={`/articles/${menu.id}`}>{formatAuthor(menu.description, 117)}</a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Column 2: USRAJ */}
                    <div className="space-y-6">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-teal-50 text-teal-500 flex items-center justify-center">
                          <span className="font-bold text-lg">U</span>
                        </div>
                        <h3 className="text-lg font-bold text-gray-800 m-0">USRAJ</h3>
                      </div>
                      <ul className="space-y-3 p-0 m-0 list-none">
                        <li><a onClick={handleAnchorClick} href="/usraj/location" className={`block text-sm transition-colors no-underline ${activePath.startsWith('/usraj') ? 'text-teal-600 font-semibold' : 'text-gray-500 hover:text-teal-500'}`}>Localisation des USRAJ</a></li>
                        <li><a onClick={handleAnchorClick} href="/service" className={`block text-sm transition-colors no-underline ${activePath.startsWith('/service') ? 'text-teal-600 font-semibold' : 'text-gray-500 hover:text-teal-500'}`}>Services</a></li>
                      </ul>
                    </div>

                    {/* Column 3: Mediatheque */}
                    <div className="space-y-6">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-purple-50 text-purple-500 flex items-center justify-center">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                        </div>
                        <h3 className="text-lg font-bold text-gray-800 m-0">Médiathèque</h3>
                      </div>
                      <div className="group block relative rounded-2xl overflow-hidden cursor-pointer" onClick={(e) => { e.preventDefault(); handleAnchorClick({ currentTarget: { getAttribute: () => '/gallery' } }); window.location.href = '/gallery'; }}>
                        <img src="/images/images.png" alt="Featured" className="w-full h-32 object-cover transform group-hover:scale-110 transition-transform duration-500" />
                        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent flex items-end p-4">
                          <a href="/gallery" className="text-white no-underline text-sm font-semibold flex items-center gap-2 group-hover:text-purple-200 transition-colors">Découvrir <svg className="w-4 h-4 transform group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative group" onMouseEnter={() => setAbout(true)} onMouseLeave={() => setAbout(false)}>
                <button className={`relative group border-none px-4 py-2 rounded-full text-sm font-semibold flex items-center gap-2 transition-all duration-300 outline-none focus:outline-none ${activePath.startsWith('/about') || activePath.startsWith('/partenaires') ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-indigo-600 hover:bg-gray-50'}`}>
                  À Propos <FontAwesomeIcon icon={faChevronDown} className={`text-[10px] transition-transform duration-300 ${about ? 'rotate-180' : ''}`} />
                </button>

                <div className={`absolute left-1/2 -translate-x-1/2 pt-4 w-screen max-w-2xl transition-all duration-300 z-50 ${about ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-4 invisible'}`}>
                  <div className="bg-white border text-left border-gray-100 rounded-3xl shadow-xl shadow-indigo-100/50 p-8 grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="space-y-6">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                        </div>
                        <h3 className="text-lg font-bold text-gray-800 m-0">Nous</h3>
                      </div>
                      <ul className="space-y-3 p-0 m-0 list-none">
                        <li><a onClick={handleAnchorClick} href='/about' className={`block text-sm transition-colors no-underline ${activePath === '/about' ? 'text-blue-600 font-semibold' : 'text-gray-500 hover:text-blue-500'}`}>Qui sommes nous ?</a></li>
                      </ul>
                    </div>

                    {partenaires.length !== 0 && (
                      <div className="space-y-6">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-xl bg-pink-50 text-pink-500 flex items-center justify-center">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                          </div>
                          <h3 className="text-lg font-bold text-gray-800 m-0">Partenaires</h3>
                        </div>
                        <ul className="space-y-3 p-0 m-0 list-none">
                          {partenaires.map((partenaire) => (
                            <li key={partenaire.name}><a onClick={handleAnchorClick} className={`block text-sm transition-colors no-underline ${activePath.startsWith('/partenaires') ? 'text-pink-600 font-semibold' : 'text-gray-500 hover:text-pink-500'}`} href={`/partenaires`}>{formatAuthor(partenaire.description || partenaire.name, 25)}</a></li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <a target="_blank" rel="noreferrer" href="https://e-learning.youthfp.cm" className={`relative group px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300 no-underline text-gray-600 hover:text-indigo-600 hover:bg-gray-50`}>
                E-Learning
              </a>
            </div>
          </div>

          {/* Right Section (UNFPA on Desktop / Hamburger on Mobile) */}
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex flex-shrink-0 items-center">
              <a href="https://cameroon.unfpa.org/" className="transition-transform hover:scale-105 no-underline" target="_blank" rel="noopener noreferrer">
                <img src="/images/logo/unfpa.png" className="block h-10 w-auto" alt="UNFPA" />
              </a>
            </div>

            {/* Mobile menu button */}
            <div className="sm:hidden flex items-center pr-2 z-50">
              <button border="none" onClick={() => setIsOpen(!isOpen)} type="button" className={`relative bg-transparent border-none w-10 h-10 transition-colors rounded-xl flex items-center justify-center focus:outline-none ${isOpen ? 'bg-indigo-50 text-indigo-600' : 'bg-transparent text-gray-600 hover:bg-gray-100'}`} aria-expanded={isOpen}>
                <span className="sr-only">Menu</span>
                <div className="w-5 h-4 relative flex flex-col justify-between">
                  <span className={`w-full h-0.5 bg-current rounded transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-[7px]' : ''}`}></span>
                  <span className={`w-full h-0.5 bg-current rounded transition-all duration-300 ${isOpen ? 'opacity-0' : ''}`}></span>
                  <span className={`w-full h-0.5 bg-current rounded transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-[7px]' : ''}`}></span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile menu overlay */}
      <div className={`sm:hidden fixed inset-0 bg-gray-900/20 backdrop-blur-sm z-40 transition-opacity duration-300 ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`} onClick={() => setIsOpen(false)}></div>

      {/* Mobile menu panel */}
      <div className={`sm:hidden fixed top-20 left-0 w-full bg-white shadow-2xl z-40 border-t border-gray-100 p-4 transition-all duration-300 origin-top flex flex-col max-h-[calc(100vh-80px)] overflow-y-auto ${isOpen ? 'scale-y-100 opacity-100 visible' : 'scale-y-95 opacity-0 invisible'}`}>
        <div className="bg-gray-50 rounded-2xl p-2 flex flex-col gap-1">
          <a href="/" onClick={(e) => { handleAnchorClick(e); setIsOpen(false); }} className={`block px-4 py-3 rounded-xl text-base no-underline font-semibold transition-colors ${activePath === '/' ? 'bg-white text-indigo-600 shadow-sm border border-gray-100' : 'text-gray-600 hover:bg-gray-100'}`}>Accueil</a>

          {/* Mobile Ressources Dropdown */}
          <div className="flex flex-col">
            <button onClick={() => setRessourcesM(!ressourcesM)} className={`border-none bg-transparent outline-none focus:outline-none w-full text-left px-4 py-3 rounded-xl text-base font-semibold flex items-center justify-between transition-colors ${activePath.startsWith('/articles') || activePath.startsWith('/usraj') || activePath.startsWith('/service') || activePath.startsWith('/gallery') ? 'bg-white text-indigo-600 shadow-sm border border-gray-100' : 'text-gray-600 hover:bg-gray-100'}`}>
              <span className="flex items-center gap-3"><FontAwesomeIcon icon={faFolderOpen} className="text-sm opacity-50" /> Ressources</span>
              <FontAwesomeIcon icon={faChevronDown} className={`text-xs transition-transform duration-300 ${ressourcesM ? 'rotate-180' : ''}`} />
            </button>
            <div className={`transition-all duration-300 overflow-hidden ${ressourcesM ? 'max-h-[1000px] opacity-100 mt-2' : 'max-h-0 opacity-0'}`}>
              <div className="pl-6 pr-2 pb-2 space-y-4 border-l-2 border-indigo-100 ml-6">
                {articleSubMenu.length !== 0 && (
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 m-0 mt-2">Articles</h4>
                    <ul className="space-y-1 p-0 m-0 list-none">
                      {articleSubMenu.map((menu) => (
                        <li key={menu.name}><a onClick={(e) => { handleAnchorClick(e); setIsOpen(false); }} className={`block py-1.5 px-3 rounded-lg text-sm no-underline transition-colors ${activePath === `/articles/${menu.id}` ? 'text-indigo-600 bg-indigo-50 font-semibold' : 'text-gray-600 hover:bg-white hover:text-indigo-500'}`} href={`/articles/${menu.id}`}>{formatAuthor(menu.description, 30)}</a></li>
                      ))}
                    </ul>
                  </div>
                )}
                <div>
                  <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 m-0 mt-2">USRAJ</h4>
                  <ul className="space-y-1 p-0 m-0 list-none">
                    <li><a onClick={(e) => { handleAnchorClick(e); setIsOpen(false); }} href="/usraj/location" className={`block py-1.5 px-3 rounded-lg text-sm no-underline transition-colors ${activePath.startsWith('/usraj') ? 'text-teal-600 bg-teal-50 font-semibold' : 'text-gray-600 hover:bg-white hover:text-teal-500'}`}>Localisation des USRAJ</a></li>
                    <li><a onClick={(e) => { handleAnchorClick(e); setIsOpen(false); }} href="/service" className={`block py-1.5 px-3 rounded-lg text-sm no-underline transition-colors ${activePath.startsWith('/service') ? 'text-teal-600 bg-teal-50 font-semibold' : 'text-gray-600 hover:bg-white hover:text-teal-500'}`}>Services</a></li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 m-0 mt-2">Médiathèque</h4>
                  <ul className="space-y-1 p-0 m-0 list-none">
                    <li><a onClick={(e) => { handleAnchorClick(e); setIsOpen(false); }} href="/gallery" className={`block py-1.5 px-3 rounded-lg text-sm no-underline transition-colors ${activePath.startsWith('/gallery') ? 'text-purple-600 bg-purple-50 font-semibold' : 'text-gray-600 hover:bg-white hover:text-purple-500'}`}>Galerie d'images</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            <button onClick={() => setAboutM(!aboutM)} className={`border-none outline-none focus:outline-none bg-transparent w-full text-left px-4 py-3 rounded-xl text-base font-semibold flex items-center justify-between transition-colors ${(activePath.startsWith('/about') || activePath.startsWith('/partenaires')) && activePath != '/' ? 'bg-white text-indigo-600 shadow-sm border border-gray-100' : 'text-gray-600 hover:bg-gray-100'}`}>
              <span className="flex items-center gap-3"><svg className="w-4 h-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg> À Propos</span>
              <FontAwesomeIcon icon={faChevronDown} className={`text-xs transition-transform duration-300 ${aboutM ? 'rotate-180' : ''}`} />
            </button>
            <div className={`transition-all duration-300 overflow-hidden ${aboutM ? 'max-h-[1000px] opacity-100 mt-2' : 'max-h-0 opacity-0'}`}>
              <div className="pl-6 pr-2 pb-2 space-y-4 border-l-2 border-indigo-100 ml-6">
                <div>
                  <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 m-0 mt-2">Nous</h4>
                  <ul className="space-y-1 p-0 m-0 list-none">
                    <li><a onClick={(e) => { handleAnchorClick(e); setIsOpen(false); }} href="/about" className={`block py-1.5 px-3 no-underline rounded-lg text-sm transition-colors ${activePath === '/about' ? 'text-blue-600 bg-blue-50 font-semibold' : 'text-gray-600 hover:bg-white hover:text-blue-500'}`}>Qui sommes nous ?</a></li>
                  </ul>
                </div>
                {partenaires.length !== 0 && (
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 m-0 mt-2">Partenaires</h4>
                    <ul className="space-y-1 p-0 m-0 list-none">
                      {partenaires.map((menu) => (
                        <li key={menu.name}><a onClick={(e) => { handleAnchorClick(e); setIsOpen(false); }} className={`block py-1.5 no-underline px-3 rounded-lg text-sm transition-colors ${activePath.startsWith('/partenaires') ? 'text-pink-600 bg-pink-50 font-semibold' : 'text-gray-600 hover:bg-white hover:text-pink-500'}`} href={`/partenaires`}>{formatAuthor(menu.name, 25)}</a></li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>

          <a target="_blank" rel="noreferrer" onClick={() => setIsOpen(false)} href="https://e-learning.youthfp.cm" className="no-underline mt-4 block text-center px-4 py-3 rounded-xl text-base font-bold text-white bg-gradient-to-r from-indigo-500 to-purple-600 shadow-md transform transition-transform hover:scale-105">
            E-Learning
          </a>
        </div>
      </div>
    </header>
  );
}
